import { render, staticRenderFns } from "./TabsQuestion.vue?vue&type=template&id=f64f6c82&"
import script from "./TabsQuestion.vue?vue&type=script&lang=js&"
export * from "./TabsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TabsQuestion.vue?vue&type=style&index=0&id=f64f6c82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports